export default {
  pageTitle: '作业总览',
  pageSub: '任务、设备与异常的实时汇总',
  postBadge: '当前视角：拣选岗位',
  allTasks: '全部任务',
  newDispatch: '+ 新建派单',
  groupOverall: '总体情况',
  groupToday: '今日概况',
  groupOps: '异常与设备',
  kpiTaskTotal: '任务总数量',
  kpiTaskTotalSub: '含全流程 / 仅拣选 / 仅复核',
  kpiTaskDone: '任务完成数量',
  kpiTaskDoneSub: '流程内全部步骤通过',
  kpiPickDone: '拣选完成数',
  kpiPickDoneSub: '拣选步骤已闭单',
  kpiCheckDone: '复核通过数',
  kpiCheckDoneSub: '复核步骤已回传',
  kpiTodayTotal: '今日任务总数量',
  kpiTodayTotalSub: '今日创建',
  kpiTodayDone: '今日任务完成数量',
  kpiTodayDoneSub: '当日已完成',
  kpiTodayRate: '今日任务完成率',
  kpiTodayRateSub: '今日完成 / 今日总数',
  kpiAvgTime: '平均单件耗时',
  kpiAvgTimeSub: '近 24 小时均值',
  kpiException: '待处置异常',
  kpiExceptionSub: '需人工闭环',
  kpiRobotOnline: '机器人在线',
  kpiRobotOnlineSub: '设备管理在线数',
  kpiRobotWorking: '机器人作业中',
  kpiRobotWorkingSub: '任务池当前派单',
  kpiPickLines: '拣选总行数',
  kpiPickLinesSub: '商品电子库在库行数',
  unitCount: '条',
  unitItem: '项',
  unitRobot: '台',
  unitLine: '行',
  unitPercent: '%',
  unitSecond: 's',
  taskListTitle: '任务列表',
  taskListHint: '按任务维度展示 · 全流程含拣选与复核，仅拣选 / 仅复核为单步骤任务',
  viewAll: '查看全部',
  colTaskNo: '任务号',
  colFlow: '流程',
  colStep: '当前步骤',
  colOrderNo: '订单号',
  colStation: '拣选 / 复核工位',
  colQty: '件数',
  colBay: '架位',
  colPosition: '停靠位',
  colPickCheck: '拣选 / 复核',
  colExcType: '异常类型',
  colStatus: '状态',
  colProgress: '进度',
  colAction: '操作',
  flowAll: '全流程',
  flowPick: '仅拣选',
  flowChk: '仅复核',
  stepPick: '拣选',
  stepCheck: '复核',
  stepNone: '待开始',
  stepPickRunning: '拣选执行',
  stepCheckRunning: '复核执行',
  stepDone: '已完成',
  statusPending: '待执行',
  statusRunning: '执行中',
  statusDone: '已完成',
  statusException: '异常',
  statusHandle: '待处置',
  posLeft: '左位 L',
  posRight: '右位 R',
  excMismatch: '商品不符',
  excTimeout: 'AGV 超时',
  excQtyMismatch: '商品数量不符',
  excPendingSuffix: ' · 待处置',
  actionDetail: '详情',
  actionHandle: '处置',
}
